import type { AuthenticationResponse } from '@/types/Response/AuthenticationResponse';
import { fsumClient } from '@/services/FsumHttpClient';
import { AuthenticationRoutes } from './routes/AuthenticationRoutes';

function login(): Promise<AuthenticationResponse> {
    return fsumClient.get(AuthenticationRoutes.LOGIN);
}

function refresh(): Promise<AuthenticationResponse> {
    return fsumClient.get(AuthenticationRoutes.REFRESH);
}

function logout(): Promise<void> {
    return fsumClient.get(AuthenticationRoutes.LOGOUT);
}

export default {
    login,
    refresh,
    logout,
};
